import React from 'react'
import "./vendor/animate/animate.css"
import "./vendor/bootstrap/css/bootstrap.min.css"
import "./fonts/font-awesome-4.7.0/css/font-awesome.min.css"
import "./vendor/css-hamburgers/hamburgers.min.css"
import "./vendor/select2/select2.min.css"
import "./css/util.css"
import "./css/main.css"
import bgimg from "./images/as.png"

export default function Form() {
    return (
        <div className='form-container'>
           
  <div className="bg-contact100">
    <div className="container-contact100">
      <div className="wrap-contact100">
        <div className="contact100-pic js-tilt" data-tilt>
          <img src={bgimg} alt="IMG" />
        </div>
        <form className="contact100-form validate-form">
          <span className="contact100-form-title">Contact Us</span>
          <div
            className="wrap-input100 validate-input"
            data-validate="Name is required"
          >
            <input
              className="input100"
              type="text"
              name="name"
              placeholder="Name"
            />
            <span className="focus-input100" />
            <span className="symbol-input100">
              <i className="fa fa-user" aria-hidden="true" />
            </span>
          </div>
          <div
            className="wrap-input100 validate-input"
            data-validate="Valid email is required: ex@abc.xyz"
          >
            <input
              className="input100"
              type="text"
              name="email"
              placeholder="Email"
            />
            <span className="focus-input100" />
            <span className="symbol-input100">
              <i className="fa fa-envelope" aria-hidden="true" />
            </span>
          </div>
          <div
            className="wrap-input100 validate-input"
            data-validate="Message is required"
          >
            <textarea
              className="input100"
              name="message"
              placeholder="Message"
              defaultValue={""}
            />
            <span className="focus-input100" />
          </div>
          <div className="container-contact100-form-btn">
            <button className="contact100-form-btn">Send</button>
          </div>
        </form>
      </div>
    </div>
  </div>

</div>

      
    )
}
